import {
  IsRequiredValidation,
  HasMaxLengthValidation,
  PostcodeValidation,
  HasFileMaxSizeValidation,
  HasMaxFilesUploadValidation
} from "@generation/form";
import { translate } from "../locales/src/translate";

export const IsRequiredValidationFactory = () =>
  new IsRequiredValidation(false, (label?: string) =>
    translate("IsRequiredValidationFactoryValidationText", { label: label ?? "" })
  );
export const HasMaxLengthValidationFactory = (maxLength?: number) =>
  new HasMaxLengthValidation(
    maxLength || 50,
    (label?: string) =>
      translate("HasMaxLengthValidationFactoryValidationText", {
        label: label ?? "",
        maxLength: maxLength?.toString() || "50"
      }),
    true
  );

export const IsPostcodeValidationFactory = () =>
  new PostcodeValidation(false, (label?: string) =>
    translate("IsPostcodeValidationFactoryValidationText", { label: label ?? "" })
  );

export const HasFileMaxSizeValidationFactory = () =>
  new HasFileMaxSizeValidation(
    5,
    (label?: string) => translate("FileMaxSizeValidationText", { label: label || "" }),
    (fileLabel?: string) => translate("FileMaxSizeValidationTextAlternative", { label: fileLabel || "" })
  );

export const HasMaxFilesUploadValidationFactory = (maxFiles?: number) =>
  new HasMaxFilesUploadValidation(maxFiles ?? 5, (label?: string) =>
    translate("FileMaxNumberOfAttachmentsValidationText", {
      label: label || "",
      maxFiles: (maxFiles ?? 5).toString(),
      bijlagen: (maxFiles ?? 5) === 1 ? translate("bijlage") : translate("bijlagen")
    })
  );
